// extracted by mini-css-extract-plugin
export default {"wrapper":"GameIcon_wrapper__dIR3M","title":"GameIcon_title__B80ya","telco":"GameIcon_telco__pB4pE","icon":"GameIcon_icon__O64WP"};